/* eslint-disable no-tabs */
import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const myMachinesServices = {
	updateMachineService,
	fetchListOfMachines,
	addNewMachine,
	fetchMachineHealthLogs,
	fetchMachineHealthSummary,
	fetchMachineHealthDashboard,
};

function fetchListOfMachines({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.LIST_MACHINES}`, requestOptions).then(
		handleResponse
	);
}

function updateMachineService({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.UPDATE_MACHINES}`, requestOptions).then(
		handleResponse
	);
}
function addNewMachine(req) {
	const { params = {} } = req ?? {};
	const url = toQueryStringURL(endpoints.ADD_MACHINE, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function fetchMachineHealthLogs({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.MACHINE_HEALTH_LOGS}`, requestOptions).then(
		handleResponse
	);
}

function fetchMachineHealthSummary({ req } = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.MACHINE_HEALTH_SUMMARY}`, requestOptions).then(
		handleResponse
	);
}

function fetchMachineHealthDashboard({ req } = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON?.stringify({
			...req?.data,
		}),
	};
	return fetch(`${endpoints.MACHINE_HEALTH_DASHBOARD}`, requestOptions).then(
		handleResponse
	);
}

export default myMachinesServices;
